import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["style"],
  _excluded2 = ["isFullscreenMode"];
import { useEffect } from 'react';
import { capabilities } from '../../../../capabilities';
import { useCapability } from '../../useCapability';
import { useNavComponentsManager } from '../../useNavComponentsManager';
export const useStylingCapabilities = () => {
  const {
    setComponentState
  } = useNavComponentsManager();
  const {
    subscribe: onRestyle
  } = useCapability(capabilities.RESTYLE_CAP.getName());
  const {
    subscribe: onToggleFullscreenMode
  } = useCapability(capabilities.TOGGLE_FULLSCREEN_MODE_CAP.getName());
  useEffect(() => onRestyle(({
    style,
    merge
  }, {
    source
  }) => {
    setComponentState(source, _ref => {
      let {
          style: prevStyle
        } = _ref,
        state = _objectWithoutPropertiesLoose(_ref, _excluded);
      return Object.assign({}, state, {
        style: merge ? Object.assign({}, prevStyle, style) : style
      });
    });
  }), [onRestyle, setComponentState]);
  useEffect(() => onToggleFullscreenMode(({
    nextValue
  }, {
    source
  }) => {
    setComponentState(source, _ref2 => {
      let {
          isFullscreenMode
        } = _ref2,
        state = _objectWithoutPropertiesLoose(_ref2, _excluded2);
      return Object.assign({}, state, {
        isFullscreenMode: nextValue !== null && nextValue !== void 0 ? nextValue : !isFullscreenMode
      });
    });
  }), [onToggleFullscreenMode, setComponentState]);
};